<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VRadioWithBlockLabel from "../../Form/Survey/VRadioWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";
import intus from "@/Plugins/intus";
import { isRequired, isMax, isMin, isInteger } from "intus/rules";

import { scrollOnError } from "@/Helpers/validation";

const props = defineProps({
    additional: Object,
    isShowSubmit: {
        Type: Boolean,
        default: true,
    },
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    what_is_your_travel_arrangement_to_sabah:
        answers?.what_is_your_travel_arrangement_to_sabah,
});

form.setError(props.additional.errors);

const emits = defineEmits("onNext");

const handleClickNext = () => {
    const validation = intus.validate(
        form.data(),
        {
            what_is_your_travel_arrangement_to_sabah: [isRequired()],
        },
        {
            ...intus.messages,
            what_is_your_travel_arrangement_to_sabah:
                surveyFields["what_is_your_travel_arrangement_to_sabah"]?.name,
        }
    );

    form.clearErrors();
    if (validation.passes()) {
        emits("onNext", form.data());
    } else {
        form.setError(validation.errors());
        setTimeout(() => scrollOnError(), 300);
    }
};
</script>

<template>
    <div>
        <div class="mb-3">
            <VRadioWithBlockLabel
                elId="what_is_your_travel_arrangement_to_sabah"
                v-model:value="form.what_is_your_travel_arrangement_to_sabah"
                :label="
                    surveyFields['what_is_your_travel_arrangement_to_sabah']
                        ?.name
                "
                :options="
                    surveyFields[
                        'what_is_your_travel_arrangement_to_sabah'
                    ]?.options.map((value) => {
                        return { id: value, description: value };
                    })
                "
                :error="form.errors?.what_is_your_travel_arrangement_to_sabah"
            />
        </div>
        <VDevider />
        <div class="text-end" v-if="isShowSubmit">
            <VButtonSubmit type="button" @onCLickSubmit="handleClickNext">
                {{ $t("public.page.survey.button.next") }}
            </VButtonSubmit>
        </div>
    </div>
</template>
